import React from 'react';
import { Card } from './Card';
import { BarChart } from '../charts/BarChart';
import { ChartInput } from '../../model/ChartInput';
import { Information } from '../Information';

const EntriesCard = ({ input, title, color, informationId }: Props) => {
  return (
    <Card className={`card-border-shadow-${color}`}>
       <div className="card-body">
        <div className="row h-100">
          <div className="col-12">
            <div className="d-flex align-items-center">
              <Information id={informationId} content={<span>{title}</span>} />
              <Information id={informationId} showMore={true} className="ms-2" />
            </div>
          </div>
          <div className="col-12">
            <BarChart datasets={input.datasets || []} labels={input.labels || []} displayGrid={false} />
          </div>
        </div>
      </div>
    </Card>);
}

interface Props {
  input: ChartInput,
  title: string,
  color: 'info' | 'orange' | 'purple',
  informationId: string
}

export { EntriesCard };
